__turbopack_context__.v({
  "amount": "SidebarCredits-module__qeKGxa__amount",
  "amountRow": "SidebarCredits-module__qeKGxa__amountRow",
  "buyBtn": "SidebarCredits-module__qeKGxa__buyBtn",
  "card": "SidebarCredits-module__qeKGxa__card",
  "icon": "SidebarCredits-module__qeKGxa__icon",
  "left": "SidebarCredits-module__qeKGxa__left",
  "title": "SidebarCredits-module__qeKGxa__title",
});
